import { render } from "./ShambaProject.vue?vue&type=template&id=5ae874f2&scoped=true&bindings={\"id\":\"props\",\"data\":\"data\",\"userId\":\"data\",\"error\":\"data\",\"projectId\":\"data\",\"success\":\"data\",\"isLoading\":\"data\",\"loaderColor\":\"data\",\"currentPage\":\"data\",\"subscribeToShamba\":\"options\",\"closeAlert\":\"options\",\"onPageChange\":\"options\",\"checkData\":\"options\"}"
import script from "./ShambaProject.vue?vue&type=script&lang=js"
export * from "./ShambaProject.vue?vue&type=script&lang=js"

import "./ShambaProject.vue?vue&type=style&index=0&id=5ae874f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ae874f2"

export default script